import { useState } from "react";
import { Play } from "lucide-react";
import { youTubeId } from "../../lib/youtube";

/** Article videos use visitor-controlled playback, with accessible player controls. */
export default function CaseStudyVideo({ url, title }) {
  const [playing, setPlaying] = useState(false);
  const id = youTubeId(url);
  if (!id) return null;
  return (
    <div className="relative aspect-video overflow-hidden rounded-brand bg-ink shadow-soft">
      {playing ? (
        <iframe
          src={`https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0&playsinline=1`}
          title={title}
          allow="autoplay; encrypted-media; picture-in-picture"
          allowFullScreen
          className="absolute inset-0 h-full w-full border-0"
        />
      ) : (
        <button
          type="button"
          onClick={() => setPlaying(true)}
          aria-label={`Play ${title}`}
          className="group absolute inset-0 flex h-full w-full cursor-pointer items-center justify-center"
        >
          <img
            src={`https://i.ytimg.com/vi/${id}/hqdefault.jpg`}
            alt=""
            loading="lazy"
            className="absolute inset-0 h-full w-full object-cover opacity-70"
          />
          <span className="relative flex items-center gap-3 rounded-brand bg-yellow px-6 py-3.5 font-bold text-slate shadow-glow transition group-hover:-translate-y-px group-hover:bg-yellow-hi">
            <Play size={20} fill="currentColor" aria-hidden="true" /> Play video
          </span>
        </button>
      )}
    </div>
  );
}
